<template>
  <div>
    <SelectItems
      label="name"
      v-model="internalFields.value"
      :items="userTypesItems"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :reduceFunction="(userType) => userType.id"
    />
    <div v-if="!loading">
      <b-badge class="mt-2 p-2 text-wrap" variant="warning" v-if="showAlert">
        <i class="fas fa-exclamation-triangle"></i>
        Tipo de usuário não habilitado para cadastro no app. Altere em
        <a
          class="px-1"
          href="/area-restrita/lojista/tipo-clientes"
          target="_blank"
        >
          Tipos de clientes
        </a>
      </b-badge>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import USER_TYPES from 'Enums/ShopkeeperApp/UserTypes.js';

import SelectItems from './SelectItems.vue';

export default {
  name: 'SelectUserTypes',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    placeholder: {
      type: String,
      default: 'Tipo de usuário',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    handleEnabledUserTypes: {
      type: Boolean,
      default: false,
      required: false,
    }
  },
  data() {
    return {
      internalFields: {
        value: '',
      },
      userTypes: {
        [USER_TYPES.CLIENT]: {
          name: 'Client',
          active: false,
        },
        [USER_TYPES.PROFESSIONAL]: {
          name: 'Professional',
          active: false,
        },
        [USER_TYPES.COMPANY]: {
          name: 'Company',
          active: false,
        },
      },
      showAlert: false,
    };
  },

  watch: {
    'internalFields.value': function () {
      this.$emit('update:value', this.internalFields.value);

      this.checkUserType();
    },
    value() {
      this.internalFields.value = this.value;
    },
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('shopkeeper', ['getUserTypesEnabled']),
    userTypesItems() {
      const items = [];

      Object.keys(USER_TYPES).forEach((key) => {
        items.push({
          id: USER_TYPES[key],
          name: this.getUserTypeText(USER_TYPES[key]),
        });
      });

      return items;
    },
  },
  async created() {
    this.internalFields.value = this.value || '';

    await this.getUserTypesAble();
  },
  methods: {
    ...mapActions('shopkeeper', ['clientesCadastro']),
    getUserTypeText(status) {
      const texts = {
        [USER_TYPES.CLIENT]: 'Cliente',
        [USER_TYPES.PROFESSIONAL]: 'Profissional',
        [USER_TYPES.COMPANY]: 'Empresa',
      };

      return texts[status] || 'N/A';
    },
    checkUserType() {
      if (this.loading) return;

      const selectedUserType = this.userTypes[this.internalFields.value];

      if (selectedUserType && !selectedUserType.active) {
        this.showAlert = true;
      } else {
        this.showAlert = false;
      }
    },
    async getUserTypesAble() {
      if (!this.getUserTypesEnabled && this.handleEnabledUserTypes) {
        await this.clientesCadastro(this.dadosUsuario.id);
      }

      const userAbleData = {
        client: this.getUserTypesEnabled.cliente,
        professional: this.getUserTypesEnabled.profissional,
        company: this.getUserTypesEnabled.empresa,
      };

      Object.keys(this.userTypes).forEach((userTypeKey) => {
        if (
          userAbleData[`${this.userTypes[userTypeKey].name.toLowerCase()}`] ===
          1
        ) {
          this.userTypes[userTypeKey].active = true;
          return;
        }

        this.userTypes[userTypeKey].active = false;
      });
    },
  },
  components: {
    SelectItems,
  },
};
</script>
